import type { QueryClient } from '@tanstack/react-query'

import { queryKeys } from './keys'

export async function invalidateNftScope(
  queryClient: QueryClient,
  nftAddress: string,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: queryKeys.nft.listRoot() }),
    queryClient.invalidateQueries({
      queryKey: queryKeys.nft.byAddress(nftAddress),
    }),
    queryClient.invalidateQueries({
      queryKey: queryKeys.nft.rewardPerPeriod(nftAddress),
    }),
    queryClient.invalidateQueries({
      queryKey: queryKeys.staking.delegations(nftAddress),
    }),
    queryClient.invalidateQueries({
      queryKey: queryKeys.staking.unbondingDelegations(nftAddress),
    }),
    queryClient.invalidateQueries({
      queryKey: queryKeys.staking.redelegations(nftAddress),
    }),
    queryClient.invalidateQueries({
      queryKey: queryKeys.bank.balances(nftAddress),
    }),
  ])
}
